import React from 'react';
import { graphql, StaticQuery, Link } from 'gatsby';
import CopyableSnippet from '../../components/utils/CopyableSnippet';

const Elements = () => (
  <React.Fragment>
    <div className="page-welcome-header">
      <h1>Elements</h1>
    </div>
    <div className="page-content">
      <blockquote>
        Elements, defined by using <i>React</i>, are the building blocks of our <Link to="/components">components</Link> and web pages.
        <br />
        Each Element can be composed by different <b>React html native dom nodes</b> (i.e. a, div, p, etc)
      </blockquote>
      <p>All the elements are exposed on a single package <CopyableSnippet code="module-tsl-ui-elements" lang="js" /></p>
      <br />
      <p>This is the list of all the elements:</p>
      <StaticQuery
        query={graphql`
          query NavElementsQuery {
            navJson {
              nav {
                name
                path
                navChildren {
                  name
                  path
                }
              }
            }
          }
        `}
        render={({ navJson: { nav } }) => {
          const allElements = nav.filter(({ name }) => name === 'Elements')[0].navChildren;
          return (
            <div className="page-boxes page-boxes-flex">
              {allElements.map(elem => (
                <Link
                  key={elem.path}
                  to={`/elements${elem.path}`}
                  className="page-box page-box--elements"
                >
                  {elem.name}
                </Link>
              ))}
              <div className="page-box page-box--empty"></div>
              <div className="page-box page-box--empty"></div>
              <div className="page-box page-box--empty"></div>
            </div>
          )
        }}
      />
    </div>
  </React.Fragment>
)

export default Elements
